import React, { useEffect, useState } from 'react'
import { Select } from 'antd';
import { Option } from 'antd/es/mentions';
import { GetAll_Food_Api } from '../../API/FoodApi';
// ======================================================================

export const FoodCombo = ({
    setLoading,
    showMessage,
    onChange
}) => {
    // ======================================================================
    const [foods, setFoods] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Food_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFoods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            // showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const handleChange = (value) => {
        if(onChange) onChange(value);
    };
    // ======================================================================
    return (
        <Select
        style={{width:'100%'}}
             onChange={handleChange}
            optionFilterProp="children"
            showSearch
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
            {foods.map((food, key) => (
                <Option key={key} value={food.id}>
                    {food.title}
                </Option>
            ))}
        </Select>
    )
}
